import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

type StatusConfig = {
    label: string;
    backgroundColor: string;
    textColor: string;
};

type StatusTagProps = {
    label?: string;
};

export const StatusTag = (props: StatusTagProps) => {
    const { label } = props;
    const { t } = useTranslation();

    if (label === undefined) {
        return null;
    }

    // Mapping des statuts backend vers les couleurs Figma
    const statusConfig: Record<string, StatusConfig> = {
        planifié: {
            label: t("action_plan.status.planned", "Planned"),
            backgroundColor: "#FFEDCE",
            textColor: "#FFB400",
        },
        planifiée: {
            label: t("action_plan.status.planned", "Planned"),
            backgroundColor: "#FFEDCE",
            textColor: "#FFB400",
        },
        terminé: {
            label: t("action_plan.status.done", "Done"),
            backgroundColor: "#DFFFE6",
            textColor: "#12A332",
        },
        terminée: {
            label: t("action_plan.status.done", "Done"),
            backgroundColor: "#DFFFE6",
            textColor: "#12A332",
        },
        "en réflexion": {
            label: t("action_plan.status.planning", "Under consideration"),
            backgroundColor: "#FEEEEB",
            textColor: "#FF7D60",
        },
        "en cours": {
            label: t("action_plan.status.in_progress", "In progress"),
            backgroundColor: "#CED4FF",
            textColor: "#5268FF",
        },
        intégré: {
            label: t("action_plan.status.review", "Integrated"),
            backgroundColor: "#FBE9FF",
            textColor: "#B249C6",
        },
        intégrée: {
            label: t("action_plan.status.review", "Integrated"),
            backgroundColor: "#FBE9FF",
            textColor: "#B249C6",
        },
    };

    const config = statusConfig[label.toLowerCase()];

    if (!config) {
        // Fallback pour les statuts non définis
        return (
            <Chip
                label={label}
                sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#6B7280",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    minHeight: "22px",
                    height: "auto",
                    borderRadius: "4px",
                    "& .MuiChip-label": {
                        padding: "2px 8px",
                        lineHeight: "1.6",
                    },
                }}
            />
        );
    }

    return (
        <Chip
            label={config.label}
            sx={{
                backgroundColor: config.backgroundColor,
                color: config.textColor,
                fontSize: "0.75rem",
                fontWeight: 600,
                minHeight: "22px",
                height: "auto",
                borderRadius: "4px",
                "& .MuiChip-label": {
                    padding: "2px 8px",
                    lineHeight: "1.6",
                },
            }}
        />
    );
};
